import axios from 'axios';
import { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { attachApiErrorToastInterceptor } from '../utils/api-error-toast';
import { deleteAllCookies } from '../config/Helper';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_SESSION_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

attachApiErrorToastInterceptor(axiosInstance);

export const useFetchSessionToken = () => {
  const [cookies, setCookie, removeCookie] = useCookies(['session_token']);
  const token = cookies.session_token;
  const [isLoading, setIsLoading] = useState(false);
  const APP_VERSION = 'v2'; // change this on each deploy

  useEffect(() => {
    const savedVersion = localStorage.getItem('app_version');

    if (!savedVersion || savedVersion !== APP_VERSION) {
      // clear bad cookies
      deleteAllCookies();

      // update version
      localStorage.setItem('app_version', APP_VERSION);
    }
  }, []);
  useEffect(() => {
    const fetchToken = async () => {
      if (!token) {
        setIsLoading(true);
        try {
          const response = await axiosInstance.post('/session-user');
          setCookie('session_token', response.data.session_token, {
            path: '/',
          });
          setTimeout(() => {
            setIsLoading(false);
          }, 2000);
        } catch (error: unknown) {
          if (error instanceof Error) {
            console.error(error);
          }
        }
      }
    };
    fetchToken();
  }, []);
  return { isLoading };
};
